

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setDirtyState } from '../../../actions/appData';
import useStyles from './styles/leaveConfirmationModal.styles'

const leaveMessage = 'You may lose all unsaved changes, do you still want to continue?';

const LeaveConfirmationModal = ({ isOpen, onClose, message=leaveMessage, onLeave }) => {

    const styles = useStyles();
    const dispatch = useDispatch();

    const handleLeave = () => {
        dispatch(setDirtyState({ isDirty: false }));
        onLeave(true);
        onClose();
    }

    const handleStay = () => {
        onLeave(false);
        onClose();
    }

    return (
        <Dialog
            className={styles.dialog}
            fullWidth
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="xs"
            open={isOpen}
            onClose={onClose}>
            <DialogTitle className={styles.title}>
                <span>Alert</span>
            </DialogTitle>
            <DialogContent className={styles.dialogContent}>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions className={styles.footer}>
                <Button
                    disableRipple
                    variant="outlined"
                    onClick={handleLeave}
                >
                    Leave
                </Button>
                <Button
                    disableRipple
                    variant="contained"
                    color="primary"
                    onClick={handleStay}
                    autoFocus
                >
                    Stay
                </Button>
            </DialogActions>
        </Dialog >

    )
}

export default LeaveConfirmationModal;